export { default } from './Text';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Text/index.jsx